declare global {
  interface Window {
    __DANKDUEL_DEBUG__?: boolean;
  }
}

const DEBUG_STORAGE_KEY = 'dank_duel_debug';

const readDebugPreference = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (typeof window.__DANKDUEL_DEBUG__ === 'boolean') {
    return window.__DANKDUEL_DEBUG__;
  }

  const storedValue = window.localStorage.getItem(DEBUG_STORAGE_KEY);
  if (storedValue === 'true') return true;
  if (storedValue === 'false') return false;

  return import.meta.env.DEV;
};

export const debugLog = (...args: unknown[]): void => {
  if (readDebugPreference()) {
    console.log(...args);
  }
};

export const debugWarn = (...args: unknown[]): void => {
  if (readDebugPreference()) {
    console.warn(...args);
  }
};
